import React from 'react';

const SpacingExample = ({ token, pixels }) => {
  return (
    <div className="flex items-center gap-4 p-3 rounded-lg bg-card border border-border">
      <div className="flex items-center gap-3 flex-1">
        <code className="text-sm font-medium text-primary min-w-[60px]">space-{token}</code>
        <span className="text-sm text-muted-foreground">=</span>
        <span className="text-sm font-medium text-foreground">{pixels}</span>
      </div>
      <div className="flex items-center gap-2">
        <div 
          className="bg-primary/20 border-2 border-primary rounded"
          style={{ width: pixels, height: '24px' }}
        />
      </div>
    </div>
  );
};

export default SpacingExample;